import { render } from "./ChangePassword.vue?vue&type=template&id=2f420f58"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__